import React, {Component} from 'react';
import {withStyles} from 'material-ui/styles';
import {Icon, Button, CircularProgress} from "material-ui";

const styles = theme => ({
    icon: {
        lineHeight: '14px',
        height: '14px',
        marginRight: '8px'
    },
    buttonProgress: {
        color: theme.palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    }
});

class BtnIcon extends Component {

    render() {
        const {loading, children, icon, classes, ...props} = this.props;
        props.disabled = props.disabled || loading;
        return (
            <Button {...props}>
                <Icon className={classes.icon}>{icon}</Icon>
                {children}
                {loading && <CircularProgress size={24} className={classes.buttonProgress}/>}

            </Button>
        )
    }

}

export default withStyles(styles)(BtnIcon);


// WEBPACK FOOTER //
// ./src/shared/BtnIcon/BtnIcon.js